export const soldBaseProductReport = {
	tabTitle: "Salida general de productos",
	filename: "informe_de_salida_general_de_productos",
	emptyText: "Sin datos para mostrar.",
	table: {
		code: "SKU",
		product: "Producto",
		count: "Cantidad",
	},
};
